<template>
  <div>
    <!--   waiting table for course-user to edit the profile open to course. -->
    <div class="col-md-12" style="text-align: right;">
      <a @click="showDetail" class="btn-edit" data-toggle="modal" data-target="#infoModal" href="#" style="font-size:11pt;text-decoration:underline;"><i class="fa fa-edit"></i>編輯</a>
    </div>
    <!-- Modal -->
    <!-- Modal -->
    <div value="show_msg" class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="infoModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="padding:0px 20px;">
          <div style="padding: 15px 0;">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group row">
                <div class="col-md-4">
                  <div class="row">
                    <img class="img-responsive" :src="!!courseInfo.cover_photo_url?courseInfo.cover_photo_url:`${require('@/assets/image/icon_upload_cover.png')}`"  style="width: 100%;" />
                    <input @change="updateImg('update', 'input[name=file_photo]:first')" type="file" name="file_photo" accept="image/jpg, image/jpeg, image/png" />
                  </div>
                  <div class="row text-center" style="margin-top: 10px;">
                    <div v-show="!courseInfo.cover_photo_url">
                      <div @click="trigger('input[name=file_photo]:first', 'click')" class="btn btn-success btn-fill">上載圖片</div>
                    </div>
                    <div v-show="!!courseInfo.cover_photo_url">
                      <div @click="trigger('input[name=file_photo]:first', 'click')" class="btn btn-success btn-fill">更換圖片</div>
                      <div @click="updateImg('remove', 'input[name=file_photo]:first')" class="btn btn-default" style="margin-left: 5px;">移除圖片</div>
                    </div>
                  </div>
                  <div v-show="!courseInfo.video_url" class="row text-center" style="margin-top: 10px;">
                    <div @click="trigger('input[name=file_video]:first', 'click')" class="btn btn-success btn-fill">上載影片</div>
                  </div>
                  <div v-show="!!courseInfo.video_url" class="row text-center" style="margin-top: 10px;">
                    <div @click="trigger('input[name=file_video]:first', 'click')" class="btn btn-success btn-fill">更換影片</div>
                    <div @click="updateVideo('remove', 'input[name=file_video]:first')" class="btn btn-default" style="margin-left: 5px;">移除影片</div>
                  </div>
                </div>
                <div class="col-md-8">
                  <label class="form-label label_text">班級名稱:</label>
                  <input class="form-control" type="text" name="name" v-model="courseInfo.name" placeholder="班級名稱" style="font-size: 17pt; font-weight: bolder; margin-bottom: 10px;" />
                  <label class="form-label label_text">班級簡介:</label>
                  <textarea v-model="courseInfo.summary" class="form-control" name="summary" rows="7"></textarea>
                </div>
              </div>
              <!-- <hr> -->
              <div class="form-group row">
                <input @change="updateVideo('update', 'input[name=file_video]:first')" type="file" name="file_video" accept="video/mp4, video/webm, video/ogg" />
                <div v-show="!!courseInfo.video_url">
                  <label class="form-label label_text">影片預覽:</label>
                  <video controls style="width: 100%;" :src="courseInfo.video_url">
                  </video>
                </div>
              </div>
            </form>
          </div>
          <div class="form-group row" style="padding-bottom: 30px;">
            <div class="col-xs-6" style="text-align: center;">
               <el-button plain @click="quit">取消</el-button>
            </div>
            <div class="col-xs-6" style="text-align: center;">
               <el-button class="save-btn" type="primary" @click="save">儲存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data () {
    return {
      api_url: this.$store.state.api_url,
      courseInfo: {}
    }
  },
  methods: {
    showDetail: function () {
      this.courseInfo = Object.assign({}, this.$parent.courseInfo)
    },
    quit: function () {
      $('#infoModal').modal('hide')
    },
    save: async function (e) {
      e.preventDefault()
      var fd = new FormData($('#infoModal').find('form')[0])
      if (fd.get('name').length === 0) {
        alert('請輸入班級名稱')
        return false
      }
      try {
        if (this.courseInfo.cover_photo_url === '' && this.$parent.courseInfo.cover_photo_url !== '') {
          // photo url existed before and remove the cover_photo_now
          fd.append('no_cover_photo', true)
        }
        if (this.courseInfo.video_url === '' && this.$parent.courseInfo.video_url !== '') {
          fd.append('no_video', true)
        }
        await this.$store.dispatch('request', {
          method: 'post',
          route: `courses/${this.courseInfo.id}`,
          data: fd
        }).then(res => {
          this.$parent.courseInfo = this.courseInfo
          $('#infoModal').attr('value', 'hide_msg')
          $('#infoModal').modal('hide')
          alert('傳送成功')
        })
      } catch (err) {
        console.log(err)
        alert('傳送失敗，請稍後再試')
      }
    },
    updateImg: function (type, sourceSelector) {
      if (type === 'update') {
        // upload new image, update the display
        let file = $(sourceSelector)[0].files[0]
        this.courseInfo.cover_photo_url = URL.createObjectURL(file)
      } else {
        // remove the existing image
        $(sourceSelector).val('')
        this.courseInfo.cover_photo_url = ''
      }
    },
    updateVideo: function (type, sourceSelector) {
      if (type === 'update') {
        // upload new image, update the display
        let file = $(sourceSelector)[0].files[0]
        this.courseInfo.video_url = URL.createObjectURL(file)
      } else {
        // remove the existing image
        $(sourceSelector).val('')
        this.courseInfo.video_url = ''
      }
    },
    trigger: function (selector, action) {
      $(selector).trigger(action)
    }
  },
  mounted: function () {
    $('#infoModal').on('hide.bs.modal', function (e) {
      if (this.getAttribute('value') === 'hide_msg') {
        this.setAttribute('value', 'show_msg')
        return true
      }
      return confirm('確定關閉')
    })
  }
}
</script>
